<template>
  <div :id="`tooltip-${unique}`">
    <c-button
      :id="'tooltip-' + unique"
      class="toggle-button"
      :disabled="disabled"
      :icon="{
        icon: 'chevron',
        color: 'blue',
      }"
      :active="value"
      @click="toggle"
    />

    <b-popover v-if="disabled" triggers="hover blur" :target="`tooltip-${unique}`">
      {{ disabledPopover }}
    </b-popover>
    <b-popover v-else :target="'tooltip-' + unique" triggers="hover" placeholder="top">
      {{ value ? "Свернуть" : "Развернуть" }}
    </b-popover>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";

let unique = 1;
export default {
  components: {
    "c-button": Button,
  },
  props: ["value", "disabled", "disabledPopover"],
  data() {
    unique += 1;
    return {
      unique,
    };
  },
  methods: {
    toggle() {
      if (!this.disabled) {
        this.$emit("input", !this.value);
      }
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";

.toggle-button.c-button {
  width: 22px;
  height: 22px;
  border: 1px solid $color-button-border;

  .c-button-tooltip {
    bottom: 20px;
  }

  &:hover {
    .c-button-tooltip {
      bottom: 24px !important;
    }
  }

  .c-button-icon {
    margin-left: -4px;
    margin-top: -2.5px;
    transform: rotate(-180deg);
    transition: transform 250ms ease-in-out;
  }

  &.c-button_active {
    .c-button-icon {
      transform: rotate(0deg);
    }
  }
}
</style>

<style scoped>
.toggle-button {
  background-color: #fff;
}
</style>
